var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2 7.45H7.45V7.2V4.25H8.55V7.2V7.45H8.8H11.75V8.55H8.8H8.55V8.8V11.75H7.45V8.8V8.55H7.2H4.25V7.45H7.2ZM0.25 8C0.25 3.72207 3.72207 0.25 8 0.25C12.2779 0.25 15.75 3.72207 15.75 8C15.75 12.2779 12.2779 15.75 8 15.75C3.72207 15.75 0.25 12.2779 0.25 8ZM1.35 8C1.35 11.6661 4.33393 14.65 8 14.65C11.6661 14.65 14.65 11.6661 14.65 8C14.65 4.33393 11.6661 1.35 8 1.35C4.33393 1.35 1.35 4.33393 1.35 8Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.ded9e65f1fad6ff4ca39827456a54e5f.svg";
export { ForwardRef as ReactComponent };